import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Button, Table, Input, Badge } from "reactstrap";

// Existencias de bodega propia hacia Mercado Libre. Primero se calcula (no
// escribe nada) y se ve la diferencia publicacion por publicacion; luego se
// mandan las elegidas o todas. Full no se toca: ese stock lo maneja Meli.
function ExistenciasMeli({ URL, headers, cuentas, areas, recargaCuentas, error }) {
  const meli = cuentas.filter((c) => c.plataforma === "Mercado Libre");
  const [cuentaId, setCuentaId] = useState("");
  const [calculo, setCalculo] = useState(null);
  const [elegidas, setElegidas] = useState({});
  const [soloDiferencias, setSoloDiferencias] = useState(true);
  const [trabajando, setTrabajando] = useState(false);
  const [conf, setConf] = useState(null);

  const cuenta = meli.find((c) => c._id === cuentaId);

  useEffect(() => {
    if (!cuentaId && meli.length) setCuentaId(meli[0]._id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cuentas]);

  useEffect(() => {
    setCalculo(null);
    setElegidas({});
    if (!cuenta) return;
    setConf({
      stockAreas: (cuenta.stockAreas || []).map((a) => a._id || a),
      stockReserva: cuenta.stockReserva || 0,
      stockPorcentaje: cuenta.stockPorcentaje === undefined ? 100 : cuenta.stockPorcentaje,
      stockMaximo: cuenta.stockMaximo || 0,
      sincronizaStock: cuenta.sincronizaStock || "No",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cuentaId]);

  function guardaConf(cambios) {
    const nueva = { ...conf, ...cambios };
    setConf(nueva);
    axios
      .patch(`${URL}Cuentas/${cuentaId}`, cambios, { headers })
      .then(() => {
        recargaCuentas();
        setCalculo(null);
      })
      .catch((e) => error(e, "No se pudo guardar"));
  }

  function cambiaFrecuencia(valor) {
    if (valor !== "No" && cuenta.modo !== "Lectura y escritura") {
      Swal.fire({
        icon: "warning",
        title: "La cuenta no esta en Lectura y escritura",
        text: 'Cambia el modo de la cuenta a "Lectura y escritura" en la pestana Cuentas para que se pueda escribir en Mercado Libre.',
      });
      return;
    }
    const textos = {
      No: "Las existencias solo se mandan a mano desde esta pantalla.",
      Cortes:
        "Se mandan cada 3 horas, despues de registrar las ventas del corte. Solo se mandan las publicaciones donde cambio el disponible de Cuory.",
      "Cada hora":
        "Se mandan cada hora. OJO: si la cuenta registra ventas solo en los cortes, entre corte y corte Cuory no sabe lo que se vendio en Meli.",
    };
    Swal.fire({
      title: `Existencias automaticas: ${valor}`,
      text: textos[valor],
      icon: valor === "No" ? "info" : "warning",
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "Cancelar",
    }).then((r) => r.isConfirmed && guardaConf({ sincronizaStock: valor }));
  }

  function calcula() {
    setTrabajando(true);
    axios
      .get(`${URL}Stock/${cuentaId}`, { headers })
      .then((res) => {
        setTrabajando(false);
        setCalculo(res.data);
        setElegidas({});
      })
      .catch((e) => {
        setTrabajando(false);
        error(e, "No se pudo calcular");
      });
  }

  function envia(ids, forzar) {
    const n = ids ? ids.length : calculo.resumen.diferencias;
    const aCero = (ids ? calculo.filas.filter((f) => ids.includes(f._id)) : calculo.filas.filter((f) => f.diferencia !== 0 && !f.noSincronizar)).filter(
      (f) => f.publicar === 0 && f.actual > 0
    ).length;
    Swal.fire({
      title: forzar ? "Mandar saltando el freno" : `Mandar existencias de ${n} publicaciones`,
      html: `<div style="text-align:left;font-size:14px">
        Se escribe el stock de <b>bodega propia</b> en Mercado Libre de ${cuenta.nombre}.
        ${aCero ? `<br><b style="color:#b91c1c">${aCero} publicaciones con stock quedan en 0 (Meli las pausa).</b>` : ""}
        <br>Cada cambio queda en "Cambios en Meli" y se puede revertir.</div>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Mandar",
      cancelButtonText: "Cancelar",
    }).then((r) => {
      if (!r.isConfirmed) return;
      setTrabajando(true);
      axios
        .post(`${URL}Stock/${cuentaId}`, { ids: ids || undefined, forzar: forzar ? "Si" : "No" }, { headers })
        .then((res) => {
          setTrabajando(false);
          recargaCuentas();
          const d = res.data || {};
          if (d.frenado) {
            Swal.fire({
              icon: "error",
              title: "Freno de seguridad",
              text: d.mensaje,
              showCancelButton: true,
              confirmButtonText: "Revise, mandar de todos modos",
              cancelButtonText: "Cancelar",
            }).then((x) => x.isConfirmed && envia(ids, true));
            return;
          }
          Swal.fire({
            icon: d.errores ? "warning" : "success",
            title: "Existencias mandadas",
            html: `<div style="text-align:left;font-size:13px">${d.mensaje}${
              d.detalle && d.detalle.length ? `<br><br><b>Errores:</b><br>${d.detalle.join("<br>")}` : ""
            }</div>`,
          });
          calcula();
        })
        .catch((e) => {
          setTrabajando(false);
          error(e, "No se pudieron mandar las existencias");
        });
    });
  }

  function excluye(f, valor) {
    axios
      .patch(`${URL}Publicaciones/${f._id}`, { noSincronizar: valor ? "Si" : "No" }, { headers })
      .then(() =>
        setCalculo((c) => ({ ...c, filas: c.filas.map((x) => (x._id === f._id ? { ...x, noSincronizar: valor } : x)) }))
      )
      .catch((e) => error(e, "No se pudo guardar"));
  }

  if (!meli.length) return <div style={{ fontSize: 13, color: "#94a3b8" }}>No hay cuentas de Mercado Libre.</div>;

  const filas = calculo ? calculo.filas.filter((f) => !soloDiferencias || f.diferencia !== 0) : [];
  const ids = Object.keys(elegidas).filter((k) => elegidas[k]);
  const r = calculo && calculo.resumen;

  return (
    <>
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "flex-end", marginBottom: 12 }}>
        <div>
          <div style={{ fontSize: 12, color: "#64748b" }}>Cuenta</div>
          <Input bsSize="sm" type="select" value={cuentaId} onChange={(e) => setCuentaId(e.target.value)} style={{ width: 180 }}>
            {meli.map((c) => (
              <option key={c._id} value={c._id}>
                {c.nombre}
              </option>
            ))}
          </Input>
        </div>
        {cuenta ? (
          <Badge color={cuenta.modo === "Lectura y escritura" ? "warning" : "secondary"} pill style={{ marginBottom: 6 }}>
            {cuenta.modo}
          </Badge>
        ) : null}
        {cuenta && cuenta.modo !== "Lectura y escritura" ? (
          <span style={{ fontSize: 12, color: "#92400e", marginBottom: 4 }}>
            Puedes calcular, pero para mandar hay que poner la cuenta en "Lectura y escritura".
          </span>
        ) : null}
      </div>

      {conf ? (
        <div style={{ background: "#f8fafc", borderRadius: 8, padding: 10, marginBottom: 12, fontSize: 12 }}>
          <div style={{ display: "flex", gap: 14, flexWrap: "wrap", alignItems: "flex-start" }}>
            <div>
              <div style={{ color: "#64748b" }}>Almacenes que cuentan (bodega propia)</div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8, maxWidth: 520 }}>
                {areas.map((a) => (
                  <label key={a._id} style={{ cursor: "pointer", marginBottom: 0 }}>
                    <input
                      type="checkbox"
                      checked={conf.stockAreas.includes(a._id)}
                      onChange={(e) =>
                        guardaConf({
                          stockAreas: e.currentTarget.checked ? [...conf.stockAreas, a._id] : conf.stockAreas.filter((x) => x !== a._id),
                        })
                      }
                      style={{ marginRight: 4 }}
                    />
                    {a.name}
                  </label>
                ))}
              </div>
              {!conf.stockAreas.length ? <div style={{ color: "#92400e" }}>Sin elegir: se usa el almacen de ventas de la cuenta (o CEDIS).</div> : null}
            </div>
            <div title="Piezas que se guardan por articulo y no se publican">
              <div style={{ color: "#64748b" }}>Reserva (pzs)</div>
              <Input bsSize="sm" type="number" min={0} defaultValue={conf.stockReserva} key={`r${cuentaId}`} onBlur={(e) => Number(e.target.value) !== conf.stockReserva && guardaConf({ stockReserva: e.target.value })} style={{ width: 80 }} />
            </div>
            <div title="Que porcentaje del disponible se publica">
              <div style={{ color: "#64748b" }}>% a publicar</div>
              <Input bsSize="sm" type="number" min={0} max={100} defaultValue={conf.stockPorcentaje} key={`p${cuentaId}`} onBlur={(e) => Number(e.target.value) !== conf.stockPorcentaje && guardaConf({ stockPorcentaje: e.target.value })} style={{ width: 80 }} />
            </div>
            <div title="Tope de piezas publicadas por publicacion. 0 = sin tope">
              <div style={{ color: "#64748b" }}>Maximo (0 = sin tope)</div>
              <Input bsSize="sm" type="number" min={0} defaultValue={conf.stockMaximo} key={`m${cuentaId}`} onBlur={(e) => Number(e.target.value) !== conf.stockMaximo && guardaConf({ stockMaximo: e.target.value })} style={{ width: 90 }} />
            </div>
            <div>
              <div style={{ color: "#64748b" }}>Mandar automatico</div>
              <Input bsSize="sm" type="select" value={conf.sincronizaStock} onChange={(e) => cambiaFrecuencia(e.target.value)} style={{ width: 200 }}>
                <option value="No">No (solo a mano)</option>
                <option value="Cortes">En los cortes (cada 3 horas)</option>
                <option value="Cada hora">Cada hora</option>
              </Input>
            </div>
          </div>
          <div style={{ color: "#475569", marginTop: 6 }}>
            A publicar = (disponible − reserva) × % , con tope. Disponible = inventario − pendiente de surtir − traspasos apartados.
            {cuenta && cuenta.ultimoEnvioStock ? (
              <>
                <br />
                <b>Ultimo envio:</b> {cuenta.ultimoEnvioStock}
              </>
            ) : null}
          </div>
        </div>
      ) : null}

      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 10, alignItems: "center" }}>
        <Button size="sm" color="info" disabled={trabajando || !cuenta || !cuenta.conectada} onClick={calcula}>
          <i class="fas fa-calculator"></i> {trabajando ? "Trabajando..." : "Calcular diferencias"}
        </Button>
        {calculo ? (
          <>
            <Button
              size="sm"
              color="success"
              disabled={trabajando || !ids.length || cuenta.modo !== "Lectura y escritura"}
              onClick={() => envia(ids)}
            >
              <i class="fas fa-upload"></i> Mandar elegidas ({ids.length})
            </Button>
            <Button
              size="sm"
              color="warning"
              disabled={trabajando || !r.diferencias || cuenta.modo !== "Lectura y escritura"}
              onClick={() => envia(null)}
            >
              <i class="fas fa-upload"></i> Mandar todas las diferencias ({r.diferencias})
            </Button>
            <label style={{ fontSize: 13, cursor: "pointer", marginBottom: 0, marginLeft: 8 }}>
              <input type="checkbox" checked={soloDiferencias} onChange={(e) => setSoloDiferencias(e.currentTarget.checked)} style={{ marginRight: 4 }} />
              Solo con diferencia
            </label>
          </>
        ) : null}
      </div>

      {r ? (
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 10, fontSize: 12 }}>
          <Badge color="primary" pill>{r.total} renglones</Badge>
          <Badge color="warning" pill>{r.diferencias} con diferencia</Badge>
          <Badge color="success" pill>{r.iguales} iguales</Badge>
          <Badge color="dark" pill title="El stock de Full lo administra Mercado Libre">
            {r.full} en Full ({Number(r.piezasFull).toLocaleString("en-US")} pzs) · no se tocan
          </Badge>
          <Badge color="danger" pill title="Amarralas en la pestana Publicaciones">{r.sinCasar} sin amarrar</Badge>
          {r.cerradas ? <Badge color="secondary" pill>{r.cerradas} cerradas / en revision</Badge> : null}
          {r.excluidas ? <Badge color="secondary" pill>{r.excluidas} excluidas</Badge> : null}
          {r.aCero ? (
            <Badge color={r.frenaria ? "danger" : "light"} pill title={`El freno detiene envios automaticos con mas de ${r.limiteFreno} a cero`}>
              {r.aCero} quedarian en 0{r.frenaria ? " · el automatico se frenaria" : ""}
            </Badge>
          ) : null}
        </div>
      ) : null}

      {calculo ? (
        <Table size="sm" striped borderless className="table-responsive-xl">
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  checked={filas.length > 0 && filas.filter((f) => !f.noSincronizar).every((f) => elegidas[f._id])}
                  onChange={(e) => {
                    const v = e.currentTarget.checked;
                    const n = {};
                    filas.filter((f) => !f.noSincronizar).forEach((f) => (n[f._id] = v));
                    setElegidas(n);
                  }}
                />
              </th>
              <th>Publicacion</th>
              <th>Titulo</th>
              <th>Articulo Cuory</th>
              <th className="text-right">Disponible Cuory</th>
              <th className="text-right">A publicar</th>
              <th className="text-right">En Meli</th>
              <th className="text-right">Diferencia</th>
              <th>Excluir</th>
            </tr>
          </thead>
          <tbody>
            {filas.slice(0, 1500).map((f) => (
              <tr key={f._id} style={f.noSincronizar ? { opacity: 0.5 } : null}>
                <td>
                  <input
                    type="checkbox"
                    disabled={f.noSincronizar}
                    checked={!!elegidas[f._id]}
                    onChange={(e) => setElegidas({ ...elegidas, [f._id]: e.currentTarget.checked })}
                  />
                </td>
                <td style={{ fontSize: 12 }}>
                  {f.permalink ? (
                    <a href={f.permalink} target="_blank" rel="noopener noreferrer">
                      {f.idPublicacion}
                    </a>
                  ) : (
                    f.idPublicacion
                  )}
                  {f.estado === "paused" ? (
                    <Badge color="secondary" pill style={{ marginLeft: 4 }}>
                      pausada
                    </Badge>
                  ) : null}
                </td>
                <td style={{ fontSize: 12, maxWidth: 260 }}>
                  {f.titulo}
                  {f.variacion ? <div style={{ color: "#64748b" }}>{f.variacion}</div> : null}
                </td>
                <td style={{ fontSize: 12 }}>
                  {f.articulo.SKU} · {f.articulo.nombre}
                </td>
                <td className="text-right" style={{ color: f.disponible < 0 ? "#b91c1c" : undefined }}>
                  {f.disponible}
                </td>
                <td className="text-right">
                  <b>{f.publicar}</b>
                </td>
                <td className="text-right">{f.actual}</td>
                <td className="text-right" style={{ color: f.diferencia > 0 ? "#15803d" : f.diferencia < 0 ? "#b91c1c" : "#94a3b8" }}>
                  {f.diferencia > 0 ? `+${f.diferencia}` : f.diferencia}
                </td>
                <td>
                  <input
                    type="checkbox"
                    title="No mandar existencias a esta publicacion"
                    checked={f.noSincronizar}
                    onChange={(e) => excluye(f, e.currentTarget.checked)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <div style={{ fontSize: 13, color: "#64748b" }}>
          "Calcular diferencias" compara el disponible de Cuory contra el stock de la ultima lectura de publicaciones. No escribe nada.
          Para comparar contra Meli al dia, primero lee las publicaciones (boton <i class="fas fa-sync"></i> en Cuentas).
        </div>
      )}
      {filas.length > 1500 ? <div style={{ fontSize: 12, color: "#64748b" }}>Se muestran 1,500 de {filas.length}.</div> : null}
    </>
  );
}

export default ExistenciasMeli;
